<template>
  <div class="parent-box">
    <van-sticky>
      <van-nav-bar
        title="领取记录"
        left-arrow
        safe-area-inset-top
        fixed
        :border="false"
      >
        <template #left>
          <div class="left-nr" @click="onClickLeft()">
            <img
              src="../../../assets/yz/monthIcon/yz_monthCard_fh.png"
              alt=""
            />
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>

    <div class="content">
      <van-tabs
        v-model:active="state.activeName"
        :swipeable="true"
        :shrink="true"
        background="none"
        line-height="0"
        line-width="0"
        @change="onTabChange"
        :key="state.activeName"
      >
        <van-tab title="优惠券" name="a">
          <get-coupon />
        </van-tab>
        <van-tab title="赠送余额" name="b">
          <get-givemoney />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { reactive, onMounted, onActivated } from "vue";
import { useStore } from "vuex";
import getCoupon from "./components/getCoupon.vue";
import getGivemoney from "./components/getGivemoney.vue";

const router = useRouter();
const store = useStore();
const state = reactive({
  activeName: "getCoupon",
});

const onTabChange = (name) => {
  state.activeName = name;
};

    const onClickLeft = () => {
      // router.back();
      window.document.location = "goBack://";
    };

</script>
<style scoped="scoped" src="../../../styles/van-sticky-nav.css"></style>
<style scoped="scoped">
.van-nav-bar {
  margin-top: 60px;
}

:deep(.van-nav-bar) {
  background: #f7f8fa;
}
:deep(.van-nav-bar__title) {
  color: #333;
}

.van-nav-bar__left img {
  width: 60px;
  height: 60px;
}

.parent-box {
  padding-top: 160px;
  height: 100vh;
  overflow: hidden;
  background-color: #f7f8fa;
  padding-left: 32px;
  padding-right: 32px;
}
.van-cell {
  width: 686px;
  height: 154px;
  background-color: #fff;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
}

.van-cell p:nth-of-type(1) {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  /* margin-bottom: 12px; */
}

.van-cell p:nth-of-type(2) {
  /* margin-top: 12px; */
  font-size: 24px;
  color: #333;
}
:deep(.van-tab) {
  width: 188px;
  height: 64px;
  background-color: #ededed;
  color: #707070;
  margin-right: 16px;
  border-radius: 198px;
  font-weight: 800;
  font-size: 24px;
}
:deep(.van-tab--active) {
  color: #00d9c3;
  background-color: rgba(0, 217, 195, 0.1);
}
</style>
